import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logged: true,
  },
  getters: {
  },
  mutations: {
    set_logged(state, logged){
      state.logged = logged
      localStorage.setItem('logged', logged)
      if (!logged) {
        localStorage.clear()
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
